import { NotFound } from "@pages/NotFound";
import { useIsCrmEnabled } from "@shared/access-control/useIsCrmEnabled";

type Props = {
  children: React.ReactNode;
};

export const CrmGuard = ({ children }: Props) => {
  const isEnabled = useIsCrmEnabled();

  if (isEnabled === null) return null;
  if (!isEnabled) return <NotFound />;
  return <>{children}</>;
};
